import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { getRoles, addRole, updateRole } from "../api/roleApi";
import { showError } from "../utils/alert";

const initialForm = {
  role_name: "",
  category: "",
  description: "",
  seniority_level: "",
};

export default function RoleForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isEdit) {
      loadRole();
    }
  }, [id]);

  const loadRole = async () => {
    try {
      const res = await getRoles({ page: 1, per_page: 1000 });
      const role = res.data.items.find((r) => r.id === parseInt(id));
      if (role) {
        setForm({
          role_name: role.role_name || "",
          category: role.category || "",
          description: role.description || "",
          seniority_level:
            role.seniority_level != null ? String(role.seniority_level) : "",
        });
      } else {
        showError("Role not found");
        navigate("/roles");
      }
    } catch (err) {
      showError("Failed to load role");
      navigate("/roles");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.role_name.trim()) {
      return showError("Role name is required");
    }

    setLoading(true);
    try {
      const payload = {
        ...form,
        seniority_level: form.seniority_level
          ? Number(form.seniority_level)
          : null,
      };
      if (isEdit) {
        await updateRole(id, payload);
      } else {
        await addRole(payload);
      }
      navigate("/roles");
    } catch (err) {
      showError(isEdit ? "Failed to update role" : "Failed to add role");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout title={isEdit ? "Edit Role" : "Add Role"}>
      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="card-title mb-3">
            {isEdit ? "Edit Role" : "Add New Role"}
          </h5>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Role name *</label>
              <input
                name="role_name"
                className="form-control"
                value={form.role_name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Category</label>
              <input
                name="category"
                className="form-control"
                value={form.category}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                name="description"
                className="form-control"
                rows="3"
                value={form.description}
                onChange={handleChange}
              />
            </div>
           
            <div className="d-flex gap-2">
              <button
                type="submit"
                className="btn skedq-accent-btn"
                disabled={loading}
              >
                {loading ? "Saving..." : isEdit ? "Update" : "Add"}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => navigate("/roles")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </AdminLayout>
  );
}
